import { Conversation } from "@/types/Conversation.js";
import { BaseEntityService } from "./BaseEntityService.js";
import api from "@/api/index.js";

export class ConversationService extends BaseEntityService<Conversation> {
	public async deleteEntity(entityId: string): Promise<any> {
		const response = await api.deleteConversation(entityId);
		return response;
	}

	public async getEntity(entityId: string): Promise<Conversation> {
		const response = await api.getConversation(entityId);
		return response;
	}
}
